import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { GROUPS } from '@constants/routes';

const Groups = lazy(
  () => import('@features/group-management/pages/v1/groups/Groups')
);

const GroupInfo = lazy(
  () => import('@features/group-management/pages/v1/group-info/GroupInfo')
);

const AddMembers = lazy(
  () => import('@features/group-management/pages/v1/add-members/AddMembersPage')
);

const EditGroup = lazy(
  () => import('@features/group-management/pages/v1/edit-group/EditGroup')
);

export const GroupRoutes: RouteObject[] = [
  {
    path: GROUPS.HOME,
    element: <Groups />
  },
  {
    path: GROUPS.GROUP_INFO,
    element: <GroupInfo />
  },
  {
    path: GROUPS.ADD_MEMBER,
    element: <AddMembers />
  },
  {
    path: GROUPS.EDIT_GROUP,
    element: <EditGroup />
  }
];

export default GroupRoutes;
